import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

class CustomerAccountList extends PureComponent {
  static propTypes = {
    onConfirmAccountUnlink: PropTypes.func.isRequired,
    customer: PropTypes.shape(),
    permissions: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    customer: {
      accounts: []
    },
    permissions: null
  };

  render() {
    const { customer, onConfirmAccountUnlink, permissions } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Account Number</th>
                <th>Capacity</th>
                <th>Linked From</th>
                <th>Linked To</th>
                <AccessControl allowedPermissions={ [ActivityPerms.customerPageEdit] }>
                  <th>Unlink</th>
                </AccessControl>
              </tr>
            </thead>
            <tbody>
              { (customer != null && customer.accounts != null && customer.accounts.length > 0)
                && customer.accounts.map(accountDtl => accountDtl != null && accountDtl.account != null && <tr key={ accountDtl.account.id }>
                  { AccessControl.hasPermission(
                    permissions,
                    [
                      ActivityPerms.accountPageEdit,
                      ActivityPerms.accountPageView
                    ]
                  ) && <td align="center"><Link className="text-bold" to={ `/account/${ accountDtl.account.id }` }>{ accountDtl.account.accountNumber }</Link></td> }
                  { !AccessControl.hasPermission(
                    permissions,
                    [
                      ActivityPerms.accountPageEdit,
                      ActivityPerms.accountPageView
                    ]
                  ) && <td align="center">{ accountDtl.account.accountNumber }</td> }
                  <td align="center">{ accountDtl.capacityString }</td>
                  <td align="center">{ moment(accountDtl.validFrom).format('MMM DD, YYYY') }</td>
                  <td align="center">{ accountDtl.linkedTo }</td>
                  <AccessControl allowedPermissions={ [ActivityPerms.customerPageEdit] }>
                    <td>
                      <center>
                        <button type="submit" className="btn btn-sm btn-danger" onClick={ () => onConfirmAccountUnlink(accountDtl.account.id) }><span className="icon icon-link" /></button>
                      </center>
                    </td>
                  </AccessControl>
                </tr>) }
              { (!customer || !customer.accounts || customer.accounts.length === 0) && <tr><td colSpan="7" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default CustomerAccountList;
